import { Form, Input, Modal, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { banInstructorById } from "store/slices/instructorsSlice";
import { closeModal } from "store/slices/modalsSlice";

const DeleteInstructorModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [form] = Form?.useForm();
    const {
        isModalOpen,
        modalType,
        modalProps: { id },
    } = useSelector((state) => state?.modals);
    const { loading } = useSelector((state) => state?.instructors);
    const open = isModalOpen && modalType === "delete_instructor";
    const onSubmit = async (values) => {
        try {
            await dispatch(
                banInstructorById({ id, argument: values?.argument })
            )?.unwrap();
            notification?.success({
                message: t("instructors.crud.block.success"),
            });
            dispatch(closeModal());
        } catch (error) {
            notification?.error({
                message: t("instructors.crud.form.error.delete"),
                description: error,
            });
        }
    };
    return (
        <Modal
            title={t("instructors.crud.block.title")}
            open={open}
            onCancel={() => dispatch(closeModal())}
            onOk={() => form?.submit()}
            afterClose={() => form?.resetFields()}
        >
            <Form
                id="delete_instructor_form"
                layout="vertical"
                onFinish={onSubmit}
                form={form}
                disabled={loading}
            >
                <Form.Item
                    label={t("instructors.crud.block.reason")}
                    name="argument"
                    rules={[
                        {
                            required: true,
                            message: t("instructors.crud.block.reason.required"),
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DeleteInstructorModal;
